// DarkModeContext.tsx
import { createContext, useContext, ReactNode } from 'react'
import { useDarkMode as useDarkModeInternal } from './useDarkMode' // 기존 훅

type DarkModeContextType = ReturnType<typeof useDarkModeInternal>
const DarkModeContext = createContext<DarkModeContextType | null>(null)

export function DarkModeProvider({ children }: { children: ReactNode }) {
	const value = useDarkModeInternal() // 전역에서 딱 한 번 state 생성
	return <DarkModeContext.Provider value={value}>{children}</DarkModeContext.Provider>
}

// 외부에서 부를 때는 그대로 useDarkMode
export function useDarkMode() {
	const ctx = useContext(DarkModeContext)
	if (!ctx) throw new Error('Wrap your app with <DarkModeProvider>')
	return ctx
}
